import ctl from '@netlify/classnames-template-literals';

export const buttonStyle = ctl(`
  relative
  flex
  cursor-pointer
  max-w-[210px]
  py-2
  px-4
  rounded-md
  bg-bright-gray
  hover:bg-anti-flash-white
`);

export const contentStyle = ctl(`
  w-full
  flex-center-between
`);
